<template>
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Two Factor Authentication - Activate</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"><i class="fas fa-times"></i></button>
            </div>
            <div class="modal-body">
                <div v-if="form.errorMessage" class="mb-3 error-message text-center">
                    <p>{{ form.errorMessage }}</p>
                </div>
                <div>
                    <h6>Activate Two-Factor Authentication</h6>
                    <p>Scan the picture below with Google Authenticator or Authy, then enter the 6-digit code it shows.</p>
                    <canvas ref="qrCanvas" class="d-block mx-auto"></canvas>
                    <p v-if="qrError" class="text-danger text-center mt-2">The picture could not be created. Use the key below instead.</p>
                    <div class="mt-3 mb-3">
                        <label class="form-label">Can't scan the picture? Enter this key manually</label>
                        <div class="d-flex align-items-center">
                            <code class="form-control mb-0" style="user-select: all; letter-spacing: 0.08em;">{{ formattedSecret }}</code>
                            <button type="button" class="btn ms-2" @click="copySecret">{{ copied ? 'Copied' : 'Copy' }}</button>
                        </div>
                    </div>
                    <form>
                        <label class="form-label">Current Authentication Code</label>
                        <input v-model="form.data.code" required placeholder="Enter the 6-digit code shown in your authentication app" class="form-control mb-0">
                        <small v-if="form.data.code.length !== 6" class="text-danger">Please enter your current 6-digit code here before activating!</small>
                    </form>
                </div>
                <hr>
                <div>
                    <button @click="activate" :disabled="form.data.code.length !== 6" class="btn">
                        <div v-if="form.processing" class="spinner-border spinner-border-sm mr-2"/>
                        Activate
                    </button>
                    <a class="btn red" data-bs-dismiss="modal" aria-label="Close">Cancel</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import QRCode from 'qrcode'
import APIClient from "@/services/APIClient.js"

export default {
    props: {
        username: String,
        secret: String
    },
    created() {
        this.apiClient = new APIClient()
    },
    mounted() {
        this.drawQr()
    },
    watch: {
        secret() {
            this.drawQr()
        },
        username() {
            this.drawQr()
        }
    },
    computed: {
        formattedSecret() {
            const raw = (this.secret || '').replace(/\s+/g, '')
            return raw.replace(/(.{4})/g, '$1 ').trim()
        }
    },
    data() {
        return {
            apiClient: null,
            qrError: false,
            copied: false,
            form: {
                errorMessage: '',
                processing: false,
                data: {
                    code: ''
                }
            }
        }
    },
    methods: {
        otpauthUrl() {
            const issuer = 'Near-Reality'
            const account = this.username || ''
            const secret = this.secret || ''
            return 'otpauth://totp/' + encodeURIComponent(issuer + ':' + account)
                + '?secret=' + encodeURIComponent(secret)
                + '&issuer=' + encodeURIComponent(issuer)
        },
        drawQr() {
            const canvas = this.$refs.qrCanvas
            if (!canvas || !this.secret) {
                return
            }
            QRCode.toCanvas(canvas, this.otpauthUrl(), (error) => {
                this.qrError = !!error
                if (error) console.error(error)
            })
        },
        copySecret() {
            const raw = (this.secret || '').replace(/\s+/g, '')
            if (!raw || !navigator.clipboard) {
                return
            }
            navigator.clipboard.writeText(raw).then(() => {
                this.copied = true
                setTimeout(() => { this.copied = false }, 2000)
            }).catch(() => {})
        },
        activate() {
            this.form.errorMessage = ''
            this.form.processing = true
            
            this.apiClient.postTwoFactorActivation(this.form.data).then((response) => {
                this.form.processing = false

                if (response.data && response.data.success) {
                    this.$emit('twoFactorActivated')
                }
            }).catch((err) => {
                this.form.processing = false
                if (err.response && err.response.data) {
                    this.form.errorMessage = err.response.data.details
                        || err.response.data.error
                        || "Could not activate two-factor authentication. Check the 6-digit code and try again."
                }
            })
        }
    }
}
</script>
